import styled from 'styled-components';

import { FormFlex } from 'components/shared/form';

const LegendFormFlex = styled(FormFlex)`
  margin-bottom: 1rem;
`;

export default LegendFormFlex;
